import { render, staticRenderFns } from "./CascoPolicy.vue?vue&type=template&id=0092c784"
import script from "./CascoPolicy.vue?vue&type=script&lang=js"
export * from "./CascoPolicy.vue?vue&type=script&lang=js"
import style0 from "./CascoPolicy.vue?vue&type=style&index=0&id=0092c784&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports